import DateLabel from "components/date-label.component";
import React, { useEffect, useState } from "react";
import { getLatestJobs } from "services/employer.service";
import { Job } from "services/types";

function HomePage() {

  const [latestJobs, setLatestJobs] = useState<Job[]>([])

  useEffect(() => {
    const loadLatestJobs = async () => {
      try {
        const response = await getLatestJobs();
        setLatestJobs(response.data);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    };

    loadLatestJobs();
  }, []);

  return (
    <React.Fragment>
      <section className="about section">
        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="section-header text-center mb-3">
            <h2 className="section-title">Manage your hiring from start to finish</h2>
          </div>

          <div className="row g-4 align-items-stretch justify-content-center">

            <div className="col-md-6 col-lg-5" data-aos="fade-up" data-aos-delay="200">
              <div className="icon-box equal-height">
                <i className="bi bi-briefcase"></i>
                <h3>Post a job</h3>
                <p>Get started with a job post.​</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-5" data-aos="fade-up" data-aos-delay="300">
              <div className="icon-box equal-height">
                <i className="bi bi-people"></i>
                <h3>Find quality applicants</h3>
                <p>Customise your post with screening tools to help narrow down to potential candidates.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-5" data-aos="fade-up" data-aos-delay="400">
              <div className="icon-box equal-height">
                <i className="bi bi-chat-dots"></i>
                <h3>Make connections</h3>
                <p>Track, message, invite, and interview directly on SailorsData.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-5" data-aos="fade-up" data-aos-delay="500">
              <div className="icon-box equal-height">
                <i className="bi bi-person-check"></i>
                <h3>Hire confidently</h3>
                <p>You’re not alone on your hiring journey. We have helpful resources for every step of the hiring process.</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      <section className="jobs section">
        <div className="container" data-aos="fade-up">

          <div className="section-header text-center mb-4">
            <h2>Latest Job Openings</h2>
            <p>Explore opportunities that match your skills and experience</p>
          </div>

          <div className="row g-4 justify-content-center">
            {latestJobs.map((job) => (
              <div className="col-lg-4 col-md-6" key={job.id}>
                <div className="job-card">
                  <div className="job-header">
                    <i className="bi bi-gear-wide-connected"></i>
                    <h4>{job.post.name}</h4>
                  </div>
                  <p><i className="bi bi-geo-alt"></i> {job.remittances.map(remit => remit.place_of_posting.name).join(',')}</p>
                  <p><i className="bi bi-briefcase"></i> Experience: {job.exp} year(s)</p>
                  <p><i className="bi bi-calendar"></i> Posted: <DateLabel created_at={job.created_at} /></p>
                  <button className="btn btn-indigo">Apply Now</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}

export default HomePage;
